import { Button, Grid, Typography } from "@mui/material";
import React, { ChangeEvent, useState } from "react";
import { PasswordField } from "../../molecules/PasswordField";
import { CustomAlert } from "../../atoms/CustomAlert";
import { IAlert } from "../../../types/alert";
import { Loader } from "../../molecules/Loader";
import { sendResetPassword } from "../../../services/user.service";

interface IProps {
  token: string;
}

export const FormRecoverPassword = ({ token }: IProps) => {
  const [value, setValues] = useState({
    token: token,
    newPassword: "",
    confirmPassword: "",
  });

  const [errorNewPassword, setErrorNewPassword] = useState({
    showError: false,
    msgError: "",
  });

  const [errorConfirmPassword, setErrorConfirmPassword] = useState({
    showError: false,
    msgError: "",
  });

  const [alert, setAlert] = useState<IAlert>({
    severity: "success",
    message: "",
    showAlert: false,
  });

  const [loading, setLoading] = useState(false);

  function handleFormChange(event: ChangeEvent<HTMLInputElement>) {
    setErrorNewPassword({ showError: false, msgError: "" });
    setErrorConfirmPassword({ showError: false, msgError: "" });
    setValues((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  }

  function handleClikResetPassword() {
    if (invalidPassword()) {
      return;
    }
    if (comparePassword()) {
      setLoading(true);
      sendResetPassword(value)
        .then((res) => {
          setAlert({
            severity: "success",
            message: `${res.message}. Serás redirigido al Login para poder ingresar a tu cuenta.`,
            showAlert: true,
          });
          //se redirige al usuario a la vista de login
          setTimeout(() => {
            window.location.href = `${process.env.REACT_APP_URL_FRONT}login`;
          }, 4500);
        })
        .catch((error) => {
          setAlert({
            severity: "error",
            message: error.response.data.message,
            showAlert: true,
          });
          setTimeout(() => {
            setAlert({ ...alert, showAlert: false });
          }, 3500);
        })
        .finally(() => setLoading(false));
    }
  }

  function invalidPassword() {
    const regexNumber =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&.,-_'"])[A-Za-z\d@$!%*?&.,-_'"]{8,15}$/;
    if (!regexNumber.test(value.newPassword)) {
      setErrorNewPassword({
        showError: true,
        msgError:
          "Formato inválido. La nueva contraseña debe contener entre 8 y 15 caracteres, al menos una mayúscula, una minúscula, un número y un caracter especial.",
      });
      return true;
    } else {
      setErrorNewPassword({ showError: false, msgError: "" });
      return false;
    }
  }

  function comparePassword() {
    if (value.newPassword === value.confirmPassword) return true;
    setErrorConfirmPassword({
      showError: true,
      msgError: "Las contraseñas no coinciden",
    });
    return false;
  }
  return (
    <>
      <Grid
        display="flex"
        gap={1}
        flexDirection="column"
        sx={{ width: "100%" }}
      >
        <PasswordField
          label="Nueva contraseña"
          id="newPassword"
          name="newPassword"
          autoComplete="newPassword"
          value={value.newPassword}
          onChange={handleFormChange}
          error={errorNewPassword.showError}
          helperText={errorNewPassword.msgError}
        />

        <PasswordField
          label="Repetir contraseña"
          id="confirmPassword"
          name="confirmPassword"
          autoComplete="confirmPassword"
          value={value.confirmPassword}
          onChange={handleFormChange}
          error={errorConfirmPassword.showError}
          helperText={errorConfirmPassword.msgError}
        />
      </Grid>

      <Grid mt={2} sx={{ width: "100%" }}>
        {alert.showAlert && (
          <Grid mt={2}>
            <CustomAlert severity={alert.severity} message={alert.message} />
          </Grid>
        )}
      </Grid>

      {loading ? (
        <Grid
          display="flex"
          justifyContent="center"
          mt={2}
          sx={{ width: "100%" }}
        >
          <Loader title="Espere un momento..." />
        </Grid>
      ) : (
        <Grid mt={2} sx={{ width: "100%" }}>
          <Button
            fullWidth
            autoFocus
            onClick={() => handleClikResetPassword()}
            variant="contained"
            disabled={alert.showAlert}
          >
            <Typography className="button-typography">
              Restaurar contraseña
            </Typography>
          </Button>
        </Grid>
      )}
    </>
  );
};
